import React, { useState, useMemo } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import useGetResolutionStatus from '../../hooks/useGetResolutionStatus';
import AddStatusModal from './components/AddStatusModal';
import useAddResolutionStatus from '../../hooks/useAddResolutionStatus';
const namespace = 'features.resolution_status';
function ResolutionStatus({ initialValue, value, onChange, allowAddNew = false, className = 'qmb-select--x-full form__field', label = translate('resolution_status', { namespace }) }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { options, isLoading, isError } = useGetResolutionStatus();
    const { mutate: addStatus, isLoading: isAddingStatus } = useAddResolutionStatus();
    const currentOptionFromValue = useMemo(() => {
        return options.find((option) => option.value === value);
    }, [options, value]);
    const defaultKendoItem = useMemo(() => {
        return options.find((option) => option.value === initialValue);
    }, [options, initialValue]);
    const handleStatusChange = (e) => {
        const selectedValue = e.value;
        onChange(Number(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value));
    };
    const handleAddStatus = (statusName) => {
        addStatus({ name: statusName }, {
            onSuccess: (response) => {
                onChange(response.id);
                setIsModalOpen(false);
            }
        });
    };
    const openAddModal = () => {
        setIsModalOpen(true);
    };
    const closeAddModal = () => {
        setIsModalOpen(false);
    };
    if (isError) {
        return React.createElement("div", { className: "error-message" }, translate('error_loading_statuses', { namespace }));
    }
    console.log({ currentOptionFromValue, defaultKendoItem });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className },
            React.createElement(DropDownList, { name: "resolutionStatus", id: "resolutionStatus", textField: "label", dataItemKey: "value", data: options, value: currentOptionFromValue, defaultItem: defaultKendoItem, onChange: handleStatusChange, size: "large", loading: isLoading }),
            React.createElement("label", { className: "qmb-label", htmlFor: "resolutionStatus" }, label)),
        allowAddNew && (React.createElement(Button, { variant: "secondary", onClick: openAddModal }, translate('add_new_status', { namespace }))),
        React.createElement(AddStatusModal, { isOpen: isModalOpen, onClose: closeAddModal, onSubmit: handleAddStatus, isLoading: isAddingStatus })));
}
export default ResolutionStatus;
